module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("DnLIj"))).then(() => parcelRequire('1iHdE'));